import moment from "moment-timezone";
import ClassTimeModel from "src/models/ClassTimeModel";
import { days } from "./constants";

export const sortByDayAndTime = (classTimes: ClassTimeModel[] = []) => {
  return [...classTimes].sort((a, b) => {
    const classTimeAStartTime = moment(a.startTime, "HH:mm");
    const classTimeBStartTime = moment(b.startTime, "HH:mm");

    let classTimeA = moment().set({
      day: days.findIndex((d) => d.value === a.day),
      hour: classTimeAStartTime.get("hour"),
      minute: classTimeAStartTime.get("minute"),
    });

    let classTimeB = moment().set({
      day: days.findIndex((d) => d.value === b.day),
      hour: classTimeBStartTime.get("hour"),
      minute: classTimeBStartTime.get("minute"),
    });

    if (a.date) {
      classTimeA = moment(a.date);
    }

    if (b.date) {
      classTimeB = moment(b.date);
    }

    return classTimeA.unix() - classTimeB.unix();
  });
};
